/**
 * Devuelve la fecha de "hoy" en la zona horaria LOCAL del navegador,
 * en formato ISO `YYYY-MM-DD`.
 *
 * ⚠️ No usar `new Date().toISOString().slice(0, 10)` para "hoy": eso
 * devuelve la fecha en UTC, lo que provoca que después de las 7–8 pm en
 * zonas horarias occidentales (DR, México, etc.) el sistema piense que
 * ya es el día siguiente.
 */
export function localDateString(d = new Date()) {
  const yyyy = d.getFullYear();
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const dd = String(d.getDate()).padStart(2, "0");
  return `${yyyy}-${mm}-${dd}`;
}

/** Fecha de hoy en local YYYY-MM-DD */
export const todayLocal = () => localDateString(new Date());

/** Suma/resta `n` días a hoy en la zona horaria local y devuelve YYYY-MM-DD */
export function addDaysLocal(n) {
  const d = new Date();
  d.setDate(d.getDate() + n);
  return localDateString(d);
}
